import React, { useEffect, useState } from "react";
import { PGET } from "../../../api/adminApi";
import CustomDatePicker from "../../common/CustomDatePicker";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";

export const MasterRegionChart = (props) => {
  const { options, height, layout } = props;
  const [dashboardData, setDashboardData] = useState([]);
  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [startDate, endDate] = dateRange;

  async function getDashboardMonthCounts() {
    if (startDate && endDate) {
      const formattedStart = startDate.toISOString().split("T")[0];
      const formattedEnd = endDate.toISOString().split("T")[0];
      const data = await PGET(
        "/services/admin/api/dashboard-reg-masters-by-regions/",
        true,
        {
          dateFrom: formattedStart,
          dateTo: formattedEnd,
        }
      );
      if (data) {
        setDashboardData(data.data);
      }
    }
  }

  // Calculate percentages
  const percentages = dashboardData.map((item) => {
    if (item.masterCount === 0) return 0;
    return ((item.activeMasterCount / item.masterCount) * 100).toFixed(1);
  });

  const data = {
    labels: dashboardData.map((item) => item.regionName),
    datasets: [
      {
        label: "Все",
        data: dashboardData.map((item) => item.masterCount),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Активные",
        data: dashboardData.map((item) => item.activeMasterCount),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  useEffect(() => {
    getDashboardMonthCounts();
  }, [startDate, endDate]);

  return (
    <div style={{ display: "" }}>
      {/* Date Picker */}
      <div style={{ width: 200, position: "absolute", right: 20, top: 20 }}>
        <CustomDatePicker
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => setDateRange(update)}
        />
      </div>

      {/* Bar Chart */}
      <Bar
        data={data}
        height={height}
        options={{
          ...options,
          ...layout,
          plugins: {
            ...options?.plugins,
            tooltip: {
              enabled: true,
              callbacks: {
                afterLabel: function (ctx) {
                  if (ctx.datasetIndex === 1 && percentages.length > 0) {
                    return `Процент: ${percentages[ctx.dataIndex]}%`;
                  }
                  return "";
                },
              },
            },
          },
        }}
      />

      {/* Bottom Percentage Panel */}
      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "space-around",
          fontSize: "10px",
          color: "#666",
        }}
      >
        {dashboardData.map((item, i) => (
          <div key={i} style={{ textAlign: "center" }}>
            <div>{item.regionName}</div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "10px",
                color: "rgba(53, 162, 235, 1)",
              }}
            >
              {percentages[i]}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

MasterRegionChart.defaultProps = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      data: [20, 60, 50, 45, 50, 60, 70, 40, 45, 35, 25, 30],
      backgroundColor: "rgb(54,122,215, 0.9)",
      barPercentage: 0.6,
    },
    {
      data: [10, 40, 30, 40, 60, 55, 45, 35, 30, 20, 15, 20],
      backgroundColor: "rgba(250,0,54,0.5)",
      barPercentage: 0.6,
    },
  ],

  options: {
    maintainAspectRatio: true,
    responsive: true,
    layout: {
      padding: { left: "0", right: 0, top: 0, bottom: "0" },
    },
    plugins: { legend: { position: "top" }, title: { display: true } },
  },
};

MasterRegionChart.propTypes = {
  height: PropTypes.number,
  labels: PropTypes.arrayOf(PropTypes.string),
  datasets: PropTypes.arrayOf(PropTypes.object),
  options: PropTypes.object,
  layout: PropTypes.object,
};
